import React, { FC } from 'react';
import { Trans } from '@lingui/macro';
// @ts-ignore
import GoogleMapsIcon from '../resources/google_maps_icon.svg';
import './maps-consent.scss';

export type MapsConsentProperties = {
  privacyPolicyUrl: string;
  consentGiven: () => void;
};

const MapsConsent: FC<MapsConsentProperties> = ({ consentGiven, privacyPolicyUrl }) => (
  <div className="dvinci-widget-maps-filter-consent text-center p-5">
    <img
      src={GoogleMapsIcon}
      alt="Google Maps Icon"
      className="dvinci-widget-maps-filter-consent-icon d-inline-block mb-4"
    />
    <p className="fs-5">
      <Trans>This content is provided by Google Maps.</Trans>
      <br />
      <Trans>
        For more information see our{' '}
        <a href={privacyPolicyUrl} rel="noreferrer" target="_blank">
          privacy policy
        </a>
        .
      </Trans>
    </p>
    <button type="button" className="btn btn-light fs-5" onClick={consentGiven}>
      <Trans>Activate</Trans>
    </button>
  </div>
);

export default MapsConsent;
